import helvetica from './helveticaGlyphWidths.json';
import times from './timesGlyphWidths.json';
import parseLatex from './parseLatex';

export function getRotatedRectHeight(bounds, angle){

  let { height, width } = bounds;
  let abstheta = Math.abs((Math.PI * 2 * angle) / 360);

  let totalHeight = width * Math.sin(abstheta) + height * Math.cos(abstheta);
  return totalHeight;

}

export default function computeCellTextBounds({data}){

  let { style={}, value } = data;

  if( typeof(value) !== 'string' ){
    return {height:0, width:0}
  }

  let fontFamily = style && style.fontFamily || 'Helvetica';
  let fontSize = style.fontSize || 12;

  let widthDict = ({Helvetica:helvetica,Times:times})[fontFamily];

  let getLineWidth = function(line){

    let latexLine = parseLatex(line);



    let properties = {
      isSubOrSuper:false
    }

    return Array.from(line).reduce((width,letter,index) => {


      let glyphWidth = Number(widthDict[letter]);


      let changeAtPoint =  latexLine[index]
      

      if( changeAtPoint ){
        let { e } = changeAtPoint;
        let { s } = changeAtPoint;
        if( e.tags && e.tags.find(t => t === "sup" || t==="sub") ){
          properties.isSubOrSuper = false;
        }

        if( s.tags && s.tags.find(t => t === "sup" || t==="sub") ){
          properties.isSubOrSuper = true;
        }
      }
      let { isSubOrSuper } = properties;
      

      let subOrSuperScale = (0.75 * Number(isSubOrSuper)) || 1;

      if( isSubOrSuper ){ }

      if( changeAtPoint && changeAtPoint.skip ){ 
        return width; 
      }

      return width + (glyphWidth * fontSize * subOrSuperScale);
    },0)
  }


  let lines = value.split('\n');
  let lineWidths = lines.map(getLineWidth);
  let width = Math.max(...lineWidths); 

  let height = lines.length * fontSize;

  let w = Number(Number(width).toFixed(3));
  let h = Number(Number(height).toFixed(3));

  return { width:w, height:h }

}



const heightPortionsOfTextContent = {
  top:{ up:0, down:1 },
  middle:{ up:0.5, down:0.5 },
  bottom:{ up:1, down:0 }
}

/*
const portionersByAngleDirection = {
  [-90]:heightPortionsOfTextContentDifferenceNegativeAngle,
  90:heightPortionsOfTextContentDifferencePositiveAngle
}
*/

export function getRotationSpacings(originalBoundsList, angles, rowIndex, cellDataThatSpanThisRowOnly,rowDimensions){
  let spacing = originalBoundsList.reduce(
    (maxes, bounds, index) => {

      let angle = angles[index];
      let copy;

      let height = {
        down:0,
        up:0
      }

      if( bounds || true ){
        let textHeight = getRotatedRectHeight(bounds,angle)
        let textOvershoot = textHeight - rowDimensions.h;

        let { verticalAlign="middle" } = cellDataThatSpanThisRowOnly[index].data.style || {};
        if( ![-90,0,90].includes(angle) ){
          verticalAlign = angle < 0 ? "bottom" : "top"
        }



        if( !verticalAlign ){
          verticalAlign = "middle";
        }

        

        if( !height ){
          debugger;
        }

        if( !heightPortionsOfTextContent[verticalAlign] ){
          debugger;
        }

        height.down = textOvershoot * (
            heightPortionsOfTextContent[verticalAlign].down
          )

          height.up = textOvershoot * (
            heightPortionsOfTextContent[verticalAlign].up
          )


        if( verticalAlign === "middle" && textOvershoot > 0){
          //debugger;
        }

      }

      return { 
        down:Math.max(maxes.down,height.down),
        up:Math.max(maxes.up, height.up)
      }



      if (angle < 0) {


        

        //we need to account for it being:
        //- in the middle
        //- at the bottom
        //- at the top?

        copy = {
          ...maxes,
          'up':Math.max(maxes.up,height.up)
        }


      } else if (angle > 0) {
        copy = {
          ...maxes,
          'down':Math.max(maxes.down,height.down)
        }
      }else{
        copy = maxes;
      }

      return copy;
    },
    { up: 0, down: 0 }
  );

  let heightDelta = originalBoundsList[0] ? originalBoundsList[0].height : 0;
  let upSpacing = Math.max(0,spacing.up - heightDelta * 0)
  let downSpacing = Math.max(0,spacing.down - heightDelta * 0)
  return { upSpacing, downSpacing };
}
